import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "react-emotion";
import play_icon_small from "assets/images/play_icon_small.svg";
import stopwatch from "assets/images/stopwatch.svg";
import { Link } from "react-router-dom";

const propTypes = {
  timeLength: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  visited: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
};

const NavItem = ({ timeLength, title, index, visited, active }) => (
  <Styled.Container visited={visited} active={active}>
    <Link to={`/tutorial?video=${index}`} className={styles.link}>
      <div className={styles.counter}>
        <span>{index + 1}</span>
        <span className="play-icon">
          <img src={play_icon_small} alt="" />
        </span>
      </div>
      <strong className={styles.itemTitle}>
        <strong>{title}</strong>
        <span>
          <img src={stopwatch} alt="" /> <span>{timeLength}</span>
        </span>
      </strong>
    </Link>
  </Styled.Container>
);

NavItem.propTypes = propTypes;
export default NavItem;

const Styled = {
  Container: styled("div")`
    .play-icon {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #2d2d2d;
      margin: 0 20px 0 10px;
      align-items: center;
      justify-content: center;
      display: flex;
    }
    ${props =>
      props.active
        ? `
    background: #151515;
    .play-icon {
      background: #e91e63;
      box-shadow: -3px 5px 5px 1px rgba(0,0,0,.2), -1px 4px 12px 10px rgba(0,0,0,.09);
  }
    }
    `
        : props.visited
          ? `
    opacity: 0.4;
  `
          : null};
    :hover {
      opacity: 1;
    }
  `,
};

const styles = {
  link: css`
    border-top: 1px solid #151515;
    width: 100%;
    padding: 20px 25px;
    align-items: center;
    color: #fff;
    display: flex;
    :hover,
    :focus {
      background: #151515;
      text-decoration: none;
      color: #e91e63;
      opacity: 1;
    }
    :hover .play-icon,
    :focus .play-icon {
      background: #e91e63;
      box-shadow: -3px 5px 5px 1px rgba(0, 0, 0, 0.2), -1px 4px 12px 10px rgba(0, 0, 0, 0.09);
    }
  `,
  counter: css`
    font-weight: 700;
    color: rgba(152, 152, 152, 0.55);
    align-items: center;
    display: flex;
  `,
  itemTitle: css`
    flex-direction: column;
    align-items: flex-start;
    display: flex;
    strong {
      font-size: 19px;
      margin-bottom: 4px;
    }
    span {
      font-weight: 400;
      font-size: 13px;
      color: rgba(152, 152, 152, 0.55);
      display: flex;
      margin-left: 4px;
    }
  `,
};



// WEBPACK FOOTER //
// ./src/pages/tutorial/aside/NavItem.jsx